module.exports = __webpack_public_path__ + "static/assets/e0f359ce2f5ad60b443bdb153a076f56.png";